<template>
  <el-dialog :title="$t('borrowTypeManage.add.title')" :visible.sync="visible" width="40%" @close="handleClose">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-form-item :label="$t('borrowTypeManage.add.typeName')" prop="typeName">
        <el-input v-model="formData.typeName" :placeholder="$t('borrowTypeManage.add.typeNamePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('borrowTypeManage.add.typeDesc')" prop="typeDesc">
        <el-input v-model="formData.typeDesc" :placeholder="$t('borrowTypeManage.add.typeDescPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('borrowTypeManage.add.seq')" prop="seq">
        <el-input v-model="formData.seq" :placeholder="$t('borrowTypeManage.add.seqPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('borrowTypeManage.add.defaultShow')" prop="defaultShow">
        <el-select v-model="formData.defaultShow" :placeholder="$t('borrowTypeManage.add.defaultShowPlaceholder')"
          style="width:100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="handleSubmit">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { saveBorrowType } from '@/api/oa/borrowTypeManageApi'

export default {
  name: 'AddBorrowType',
  data() {
    return {
      visible: false,
      formData: {
        typeName: '',
        typeDesc: '',
        seq: '',
        defaultShow: '',
        communityId: ''
      },
      rules: {
        typeName: [
          { required: true, message: this.$t('borrowTypeManage.validate.typeNameRequired'), trigger: 'blur' },
          { max: 100, message: this.$t('borrowTypeManage.validate.typeNameMaxLength'), trigger: 'blur' }
        ],
        typeDesc: [
          { max: 500, message: this.$t('borrowTypeManage.validate.typeDescMaxLength'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('borrowTypeManage.validate.seqRequired'), trigger: 'blur' },
        ],
        defaultShow: [
          { required: true, message: this.$t('borrowTypeManage.validate.defaultShowRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.visible = true
      this.formData.communityId = getCommunityId()
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveBorrowType({
              ...this.formData,
              seq: Number(this.formData.seq)
            })
            this.$message.success(this.$t('common.operationSuccess'))
            this.visible = false
            this.$emit('success')
          } catch (error) {
            this.$message.error(this.$t('borrowTypeManage.add.error'))
          }
        }
      })
    }
  }
}
</script>